export const InsomnioCatalog = [
    "1 Dificultad para dormir ",
    "2 Dificultad para mantener el sueño",
    "3 Me despierto muy temprano"
];

export const InsomnioOptions = [
    { label: "Ninguno", value: 0 },
    { label: "Poco", value: 1 },
    { label: "Moderado", value: 2 },
    { label: "Severo", value: 3 },
    { label: "Muy severo", value: 4 }
]

export const insomniCatalog2 = [
    {
        label: "4 ¿Qué tan satisfecho/insatisfecho estás con tu patrón de sueño actual? ",
        responses: [
            "Muy satisfecho",
            "Satisfecho",
            "Moderadamente satisfecho ",
            "Insatisfecho",
            "Muy insatisfecho",
        ]
    },
    {
        label: "5 ¿Qué tan NOTABLE para los demás cree que es su problema del sueño en términos de deterioro de su calidad de vida? ",
        responses: ["No es notable ", "Un poco notable ", "Moderadamente notable ",  "Muy notable ", "Demasiado notable "]
    },
    {

        label: "6 ¿Qué tan PREOCUPADO/ANGUSTIADO está por su problema de sueño actual?",
        responses: [
            "Para nada preocupado",
            "Un poco preocupado",
            "Moderadamente preocupado",
            "Muy preocupado",
            "Demasiado preocupado",
        ]
    },
    {
        label: "7 ¿Hasta qué punto considera que su problema de sueño INTERFIERE con su funcionamiento diario (por ejemplo, fatiga durante el día, estado de ánimo, capacidad para funcionar en el trabajo/tareas diarias, concentración, memoria, estado de ánimo, etc.) ACTUALMENTE? ",
        responses: [
            "No interfiere",
            "Interfiere un poco",
            "Interfiere",
            "Moderadamente",
            "Interfiere mucho",
            "Interfiere demasiado"
        ]
    }
]